module.exports = __webpack_public_path__ + "static/media/list-alt.b3a45c8f.svg";